export default "__VITE_ASSET__Yg1mXn_R__"